import React from 'react';
import { MdCloudUpload, MdClose } from "react-icons/md";
import PropTypes from "prop-types";
import {isSupportedImage} from "../../../constants/constants";

function FileUpload({setFormData, setErrors, setDisableNextButton, handleFileUpload, formData, errors, t}) {



    const IMAGE_UPLOAD_LIMIT = parseInt(window?.appConfig?.REACT_APP_IMAGE_UPLOAD_LIMIT || process.env.REACT_APP_IMAGE_UPLOAD_LIMIT) || 50;
    const handleUpload = (files, type) => {
        if (type === 'file') {
            const docFile = files[0];
            if  (
                docFile &&
                (docFile.type === 'application/pdf' ||
                    docFile.type === 'application/msword' ||
                    docFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')
            ) {
                setFormData(prev => ({ ...prev, file: docFile }));
                setErrors(prev => ({ ...prev, file: '' }));
                handleFileUpload(files);
            } else {
                setErrors(prev => ({ ...prev, file: t("pdfOnlyError") }));
            }
        } else if (type === 'files') {
            const validFiles = files.filter(isSupportedImage);

            if (validFiles.length === 0) {
                setErrors(prev => ({ ...prev, files: t("imagesOnlyError") }));
                return;
            }

            if (validFiles.length > IMAGE_UPLOAD_LIMIT) {
                setErrors(prev => ({ ...prev, files: `${t("imagesUploadLimit")} ${IMAGE_UPLOAD_LIMIT}` }));
                return;
            }

            setFormData(prev => ({ ...prev, files: validFiles }));
            setErrors(prev => ({ ...prev, files: '' }));
            handleFileUpload(validFiles);
        }
    };

    const handleFileDelete = (event, fileType) => {
        event.preventDefault();
        if (fileType === 'file') {
            setFormData(prev => ({ ...prev, file: null, title: '' }));
        } else if (fileType === 'files') {
            setFormData(prev => ({ ...prev, files: [], title: '' }));
        }
        setErrors(prev => ({ ...prev, file: '', files: '' }));
        setDisableNextButton(true)
    };

    return (
        <div style={styles.container}>
            {!formData.files?.length && (<div style={styles.box}>
                <label htmlFor="pdfUpload" className="label-style">{t("uploadDocument")}</label>
                <div
                    style={styles.dropZone}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                        e.preventDefault();
                        handleUpload(Array.from(e.dataTransfer.files), 'file');
                    }}
                >
                    <input
                        type="file"
                        id="pdfUpload"
                        accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        style={{display: 'none'}}
                        onChange={(e) => {
                            e.preventDefault();
                            handleUpload(Array.from(e.target.files), 'file');
                            e.target.value = null;
                        }}
                    />
                    <label htmlFor="pdfUpload" style={styles.label}>
                        <MdCloudUpload size={48}/>
                        <p>{formData?.file?.name || t("addOrDragFile")}</p>
                        {formData?.file?.name && (
                            <MdClose
                                size={24}
                                style={styles.deleteIcon}
                                onClick={(e) => handleFileDelete(e, 'file')}
                            />
                        )}
                    </label>
                </div>
                {errors?.file && <p className="error-text">{errors.file}</p>}
            </div>)}

            {!formData.file && (<div style={styles.box}>
                <label htmlFor="imageUpload" className="label-style">{t("uploadImageFiles")}</label>
                <div
                    style={styles.dropZone}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                        e.preventDefault();
                        handleUpload(Array.from(e.dataTransfer.files), 'files');
                    }}
                >
                    <input
                        type="file"
                        id="imageUpload"
                        accept="image/png,image/jpeg,image/jpg,image/gif,image/tif,image/tiff,.tif,.tiff"
                        style={{display: 'none'}}
                        multiple
                        onChange={(e) => {
                            e.preventDefault();
                            handleUpload(Array.from(e.target.files), 'files');
                            e.target.value = null;
                        }}
                    />
                    <label htmlFor="imageUpload" style={styles.label}>
                        <MdCloudUpload size={48}/>
                        <p>
                            {formData?.files?.length
                                ? formData.files.map(file => file.name).join(', ')
                                :  t("addOrDragImages")}
                        </p>
                        {formData?.files?.length > 0 && (
                            <MdClose
                                size={24}
                                style={styles.deleteIcon}
                                onClick={(e) => handleFileDelete(e, 'files')}
                            />
                        )}
                    </label>
                </div>
                {errors?.files && <p className="error-text">{errors.files}</p>}
            </div>)}
        </div>
    );
}

FileUpload.propTypes = {

    setFormData: PropTypes.func,
    setErrors: PropTypes.func,
    setDisableNextButton: PropTypes.func,
    handleFileUpload: PropTypes.func,
    t: PropTypes.func,
    formData: PropTypes.shape({
        file: PropTypes.object,
        files: PropTypes.arrayOf(PropTypes.object),
    }),
    errors: PropTypes.shape({
        file: PropTypes.string,
        files: PropTypes.string,
    }),
}

const styles = {
    container: {
        justifyContent: 'center',
        gap: '20px',
        display: 'flex',
        marginBottom: '20px'
    },
    box: {
        flex: '1 1 300px',
        maxWidth: '400px',
    },
    dropZone: {
        border: '2px dashed #cdcecf',
        borderRadius: '8px',
        padding: '20px',
        textAlign: 'center',
        position: 'relative',
        minHeight: '150px',
    },
    label: {
        cursor: 'pointer',
        fontSize: "1rem",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    progress: {
        marginTop: 10,
        color: "black"
    },
    deleteIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        cursor: 'pointer',
        color: 'red'
    }
};

export default FileUpload;
